/* eslint-disable no-var, no-unused-vars */
window.YP = window.YP ?? {
    Guichet: {},
    Cart: [],
};
